// Hideo - link helpers: addresses typed without a scheme, YouTube thumbnails, web images, the links a script may keep

/** Adds https:// to an address typed without a scheme ('' stays '') */
export function normUrl(u: unknown): string {
  const s = String(u || '').trim()
  return s && !/^[a-z][a-z0-9+.-]*:/i.test(s) ? 'https://' + s : s
}
/** Thumbnail of a YouTube link (youtu.be/, v=, shorts/, embed/), '' for other links */
export function ytThumb(u: unknown): string {
  const m = String(u || '').match(/(?:youtu\.be\/|v=|shorts\/|embed\/)([\w-]{11})/)
  return m ? `https://img.youtube.com/vi/${m[1]}/hqdefault.jpg` : ''
}
/** A web image address: http(s)://domain.xx/… (pasted image URLs stay links, they are not uploaded) */
export const isWebImg = (u: unknown): boolean => /^https?:\/\/[^\s/]+\.[^\s/]+\/?\S*$/i.test(String(u || '').trim())

/** Schemes a link in a script may have (cleanHtml in src/features/editor/html.ts); an address without a scheme
 *  (#anchor, /path, page.html, //host/…) is allowed too */
const LINK_SCHEMES: readonly string[] = ['http', 'https', 'mailto', 'tel']
/** The scheme of an href as the browser reads it: leading and trailing spaces and control characters dropped, tabs
 *  and line breaks removed everywhere (entities are already decoded by the HTML parser). '' = no scheme (a relative
 *  address). Anything before the first ':' that comes before any '/', '?' or '#' counts as a scheme, even when the
 *  browser would not accept it as one: unknown schemes are refused anyway. */
export function hrefScheme(u: unknown): string {
  const s = String(u ?? '').replace(/^[\u0000- ]+|[\u0000- ]+$/g, '').replace(/[\t\n\r]/g, '')
  const m = s.match(/^([^/?#]*?):/)
  return m ? m[1].toLowerCase() : ''
}
/** An href that is safe to keep in a script: a relative address or one of LINK_SCHEMES */
export const safeLinkHref = (u: unknown): boolean => { const s = hrefScheme(u); return !s || LINK_SCHEMES.includes(s) }
/** href of a link opened in a new tab: http(s) addresses only, anything else '#' (cards, rows, creator links) */
export const openHref = (u: string): string => (/^https?:\/\//i.test(u) ? u : '#')
